import Login from '../views/Login/index.js';
import Dashboard from '../views/Dashboard/index.js';
import CategoryPage from '../views/categoryManagement/index.js';
import FarmerManagement from '../views/farmerManagement/index.js';
import RetailerManagement from '../views/retailerManagement/index.js';
import DistributorManagement from '../views/distributorManagement/index.js';
import AgriExpertManagement from '../views/agriExpertManagement/index.js';
import FarmerVisit from '../views/farmerVisits/index.js';
import RetailerVisit from '../views/retailerVisits/index.js';
import DistributorVisit from '../views/distributorVisits/index.js';
import VanCampaign from '../views/vanCampaign/index.js';
import SpotDemo from '../views/spotDemo/index.js';
import NormalDemo from '../views/normalDemo/index.js';
import LpdDemoActivity from '../views/lpdDemoActivity/index.js';
import FarmerMeet from '../views/farmerMeet/index.js';
import KvkVisit from '../views/kvkVisit/index.js';
import KrishiMela from '../views/krishiMela/index.js';
import FeedbackReport from '../views/feedbackReport/index.js';
import TestDashboard from '../views/testDashboard/index.js';
import MappingManager from '../views/mappingManagement/index.js';
import VisitManager from '../views/visitManagement/index.js';
import EventManager from '../views/eventManagement/index.js';
import OrderManagement from '../views/orderManagement/index.js';
import Consolidated from '../views/consolidated/index.js';
import Testing from '../views/testing/index.js';
import AgriExpertVisit from '../views/agriExpertVisit/index.js';
import UserManagement from '../views/userManagement/index.js';
import FinanceManagement from '../views/financeManagement/index.js';
import SfaDashboard from '../views/sfa/dashboard/index.js';
import ViewTarget from './../views/sfa/view-target/ViewTarget';
import ActivityDashboard from '../views/target-activity/dashboard/ActivityDashboard.js';
import ViewTargetAchievement from '../views/target-activity/view-target-achievement/ViewTargetAchievement.js';
import AssignTargetAchievement from '../views/target-activity/assign-target-achievement/AssignTargetAchievement.js';
import DraftExpense from '../views/promotional-expense/draft-expense/DraftExpense.js';
import ClaimExpense from '../views/promotional-expense/claim-expense/ClaimExpense.js';
import ApprovalExpense from '../views/promotional-expense/approval-expense/ApprovalExpense.js';
import NotFound from '../views/NotFound/NotFound.js';
import AssignedTargetAchievement from '../views/target-activity/assigned-target-achievement/AssignedTargetAchievement.js';
import HistoryExpense from '../views/promotional-expense/history-expense/HistoryExpense.js';
import DistributorMapping from '../views/distributor-mapping/DistributorMapping.js';
import DistributorOverview from '../views/distributor-mapping/distributor-overview/DistributorOverview.js';

function routes(loggedIn, user) {
  return [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      redirect: user,
      pathTo: !user && '/login',
      hideNavBar: true,
    },
    {
      path: '/',
      name: 'Home',
      component:
        user &&
        (user?.profile__c === 'RM' ||
          user?.profile__c === 'RMM' ||
          user?.profile__c === 'VP' ||
          user?.profile__c === 'ZM' ||
          user?.profile__c === 'AM' ||
          user?.profile__c === 'SI' ||
          user?.profile__c === 'Finance')
          ? ActivityDashboard
          : user?.profile__c === 'Depot Manager'
          ? OrderManagement
          : Login,
      hideNavBar: true,
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      hideNavBar: true,
    },
    // {
    //   path: '/page-not-found',
    //   name: 'Not Found',
    //   component: NotFound,
    //   hideNavBar: true,
    // },
    {
      path: '/category',
      name: 'Category',
      component: CategoryPage,
      hideNavBar: false,
    },
    {
      path: '/farmermapping',
      name: 'Farmer Management',
      component: FarmerManagement,
      hideNavBar: false,
    },
    {
      path: '/retailermapping',
      name: 'Reatailer Mapping',
      component: RetailerManagement,
      hideNavBar: false,
    },
    {
      path: '/distributormapping',
      name: 'Reatailer Mapping',
      component: DistributorManagement,
      hideNavBar: false,
    },
    {
      path: '/distributor-overview',
      name: 'Distributor Overview',
      component: DistributorOverview,
      hideNavBar: true,
    },
    {
      path: '/agriexpertmapping',
      name: 'Agri-Expert Mapping',
      component: AgriExpertManagement,
      hideNavBar: false,
    },
    {
      path: '/farmervisit',
      name: 'Farmer Visits',
      component: FarmerVisit,
      hideNavBar: false,
    },
    {
      path: '/retailervisit',
      name: 'Retailer Visits',
      component: RetailerVisit,
      hideNavBar: false,
    },
    {
      path: '/distributorvisit',
      name: 'Distributor Visits',
      component: DistributorVisit,
      hideNavBar: false,
    },
    {
      path: '/vancampaign',
      name: 'Van Campaign',
      component: VanCampaign,
      hideNavBar: false,
    },
    {
      path: '/spotDemo',
      name: 'Spot Demo ',
      component: SpotDemo,
      hideNavBar: false,
    },
    {
      path: '/normalDemo',
      name: 'Normal Demo ',
      component: NormalDemo,
      hideNavBar: false,
    },
    {
      path: '/lpdActivity',
      name: 'LPD Activity ',
      component: LpdDemoActivity,
      hideNavBar: false,
    },
    {
      path: '/farmermeet',
      name: 'Farmer Meet ',
      component: FarmerMeet,
      hideNavBar: false,
    },
    {
      path: '/kvkvisit',
      name: 'KVK Visit',
      component: KvkVisit,
      hideNavBar: false,
    },
    {
      path: '/krishimela',
      name: 'Krishi Mela',
      component: KrishiMela,
      hideNavBar: false,
    },
    {
      path: '/feedbackreport',
      name: 'Feedback Report',
      component: FeedbackReport,
      hideNavBar: false,
    },
    {
      path: '/testDashboard',
      name: 'Feedback Report',
      component: TestDashboard,
      hideNavBar: false,
    },
    {
      path: '/mappingreport',
      name: 'Mapping Report',
      component: MappingManager,
      hideNavBar: false,
    },
    {
      path: '/visitreport',
      name: 'Visit Report',
      component: VisitManager,
      hideNavBar: false,
    },
    {
      path: '/eventreport',
      name: 'Visit Report',
      component: EventManager,
      hideNavBar: false,
    },
    {
      path: '/orderreport',
      name: 'Order Report',
      component: OrderManagement,
      hideNavBar: false,
    },
    {
      path: '/financialreport',
      name: 'Financial Report',
      component: FinanceManagement,
      hideNavBar: true,
    },
    {
      path: '/sfa-dashboard',
      name: 'SFA Dashboard',
      component: SfaDashboard,
      hideNavBar: true,
    },
    {
      path: '/view-target',
      name: 'View Target',
      component: ViewTarget,
      hideNavBar: true,
    },
    {
      path: '/consolidated',
      name: 'Consolidated',
      component: Consolidated,
      hideNavBar: false,
    },
    {
      path: '/testing',
      name: 'Consolidated',
      component: Testing,
      hideNavBar: false,
    },
    {
      path: '/agriexpertvisit',
      name: 'Agri-Expert Visit',
      component: AgriExpertVisit,
      hideNavBar: false,
    },
    {
      path: '/usermanagement',
      name: 'User Management Visit',
      component: UserManagement,
      hideNavBar: false,
    },
    // Target Achievement
    {
      path: 'activity-dashboard',
      name: 'Activity Dashboard',
      component: ActivityDashboard,
      hideNavBar: true,
    },
    {
      path: 'view-target-achievement',
      name: 'View Target Achievement',
      component: ViewTargetAchievement,
      hideNavBar: true,
    },
    {
      path: 'assign-target-achievement',
      name: 'Assign Target Achievement',
      component: AssignTargetAchievement,
      hideNavBar: true,
    },
    {
      path: 'assigned-target-achievement',
      name: 'Assigned Target Achievement',
      component: AssignedTargetAchievement,
      hideNavBar: true,
    },
    // Promotional Expense
    {
      path: 'draft-expense',
      name: 'Draft Expense',
      component: DraftExpense,
      hideNavBar: true,
    },
    {
      path: 'claim-expense',
      name: 'Claim Expense',
      component: ClaimExpense,
      hideNavBar: true,
    },
    {
      path: 'approval-pending-expense',
      name: 'Approval Pending Expense',
      component: ApprovalExpense,
      hideNavBar: true,
    },
    {
      path: 'history-expense',
      name: 'History Expense',
      component: HistoryExpense,
      hideNavBar: true,
    },
    {
      path: 'distributor-mapping',
      name: 'Distributor Mapping',
      component: DistributorMapping,
      hideNavBar: true,
    },
    {
      redirect: loggedIn === true,
      path: '*',
      pathTo: '/activity-dashboard',
    },
  ];
}

export default routes;
